import React, { ReactNode } from 'react'
import usdtIcon from '../../../src/assets/svg/usdt.svg'

interface CurrencyIconProps {
  name: 'USDT' | 'wUSDT' // Extend this list if needed
  width?: number
  height?: number
  children?: ReactNode
}

const currencyImages: Record<string, string> = {
  USDT: usdtIcon,
  wUSDT: '/images/wusdt.svg'
}

export default function CurrencyIcon({ name, width = 20, height = 20, children }: CurrencyIconProps) {
  return (
    <div style={{ display: 'flex', alignItems: 'center', flexDirection: 'row', gap: '4px' }}>
      <img
        src={currencyImages[name] || currencyImages['USDT']}
        alt={name}
        width={width}
        height={height}
        className="mr-1"
      />
      {children}
    </div>
  )
}
